export { default } from './store-details.component';
